import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=6bcc47b0"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"
import style0 from "./DeviceCard.vue?vue&type=style&index=0&id=6bcc47b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports